import { css } from 'styled-components';
import { breakpoints } from 'modules/breakpoints';
import { themeGet } from 'modules/tetrisTheme';
import { isValidThemePath } from 'modules/tetrisTheme/isValidThemePath';
import { cssPropertyThemeKey } from './cssPropertyToThemeKey';
import { valueGuard } from './valueGuard';
/**
 * media query helper. Styles will be applied to the breakpoint and larger.
 *
 * `base` is the default and will apply where no breakpoint matches.
 *
 * @example
 * responsiveProperty('padding', '1rem');
 *
 * responsiveProperty('padding', {
 *   base: `0`,
 *   sm: `1rem`,
 *   lg: `2rem`,
 * });
 *
 */
export function responsiveProperty(property, values) {
    if (!values) {
        return css ``;
    }
    const mappableValues = valueGuard(values);
    const themePath = cssPropertyThemeKey(property);
    const arrayValues = Object.entries(mappableValues).reduce((acc, [key, value]) => {
        const path = `${themePath}.${value}`;
        const isThemePath = isValidThemePath(path);
        const cssValue = (isThemePath ? themeGet(path) : value);
        if (key === 'base') {
            return Object.assign(Object.assign({}, acc), { [property]: cssValue });
        }
        const breakpoint = breakpoints[key];
        return Object.assign(Object.assign({}, acc), { [breakpoint]: {
                [property]: cssValue,
            } });
    }, {});
    return css(arrayValues);
}
